export default {
  methods: {
    reportStatusColor (status) {
      switch (status) {
        default:
        case 'DRAFT': return 'grey'
        case 'PUBLISHED': return 'green'
      }
    },
    reportStatusName (status) {
      switch (status) {
        default:
        case 'DRAFT': return 'Draft'
        case 'PUBLISHED': return 'Published'
      }
    },
    reportStatusOptions (withAll = false) {
      const arr = [
        { label: 'Draft', value: 'DRAFT', color: 'grey' },
        { label: 'Published', value: 'PUBLISHED', color: 'green' }
      ]
      if (withAll) {
        arr.unshift({ value: null, label: 'All Reports' })
      }
      return arr
    },
    availableReportStatuses () {
      return this.reportStatusOptions()
    }
  }
}
